import React, { Fragment, useEffect, useState } from "react";
import MaterialTable from "../../../../components/materialTable";
import DialogAdd from "./dialogAdd";
import DialogUpdate from "./dialogUpdate";
import DialogDelete from "./dialogDelete";
import * as Permissions from "../../../../constants/permissions";
import { CheckPermiso } from "../../../../services/utilities/common";

export default function Page(props) {
	let {
		usuarios,
		permisos,
		is_loading,
		mutate_usuarios,
	} = props;

	const [IsOpen, SetIsOpen] = useState({});

	useEffect(() => {
		if (usuarios && usuarios.data) {
			for (const usuario of usuarios.data) {
				let nombre = usuario._usuario_ref.nombre;
				let apellidoPaterno = usuario._usuario_ref.apellido_paterno;
				let apellidoMaterno = usuario._usuario_ref.apellido_materno;
				usuario["nombre_completo"] = `${nombre} ${apellidoPaterno} ${apellidoMaterno}`;
			}
		}
	}, [usuarios]);

	let columns = [
		{
			title: "Nombre",
			field: "nombre_completo",
		}, {
			title: "Correo",
			field: "_usuario_ref.contacto.email",
		}, {
			title: "Cant. permisos",
			field: "permisos.length",
		},
	];

	let actions = [
		{
			icon: "edit",
			tooltip: "Actualizar",
			hidden: !CheckPermiso(permisos, Permissions.ADMIN_AJUSTES_USUARIOS_PLATAFORMA_EDITAR),
			onClick: (event, row) => SetIsOpen({ tipo: "update", data: row }),
		}, {
			icon: "delete",
			tooltip: "Eliminar (Requiere confirmación)",
			hidden: !CheckPermiso(permisos, Permissions.ADMIN_AJUSTES_USUARIOS_PLATAFORMA_ELIMINAR),
			onClick: (event, row) => SetIsOpen({ tipo: "delete", data: row }),
		}, {
			icon: "add",
			tooltip: "Agregar",
			isFreeAction: true,
			hidden: !CheckPermiso(permisos, Permissions.ADMIN_AJUSTES_USUARIOS_PLATAFORMA_AGREGAR),
			onClick: (event, row) => SetIsOpen({ tipo: "add", data: null }),
		},
	];

	const handleCloseDialog = () => {
		SetIsOpen({});
	}

	return (
		<Fragment>
			{/* LISTADO DE USUARIOS PLATAFORMA */}
			<MaterialTable
				title="Usuarios"
				is_loading={is_loading}
				data={usuarios?.data}
				columns={columns}
				actions={actions}
				export_excel={true}
				export_spreadsheet={true}
			/>

			{/* DIALOG PARA AGREGAR */}
			{IsOpen.tipo === "add" && (
				<DialogAdd
					is_open={IsOpen.tipo === "add"}
					usuarios={usuarios?.data}
					handle_close={handleCloseDialog}
					mutate_usuarios={mutate_usuarios}
				/>
			)}

			{/* DIALOG PARA ACTUALIZAR */}
			{IsOpen.tipo === "update" && (
				<DialogUpdate
					is_open={IsOpen.tipo === "update"}
					data={IsOpen.data}
					handle_close={handleCloseDialog}
					mutate_usuarios={mutate_usuarios}
				/>
			)}

			{/* DIALOG PARA ELIMINAR */}
			{IsOpen.tipo === "delete" && (
				<DialogDelete
					is_open={IsOpen.tipo === "delete"}
					data={IsOpen.data}
					handle_close={handleCloseDialog}
					mutate_usuarios={mutate_usuarios}
				/>
			)}
		</Fragment>
	);
}